import ApiClient from '../ApiClient';

class PipelinesAPI extends ApiClient {
  constructor() {
    super('pipelines', {
      saas: true,
      accountScoped: true,
    });
  }
}

export default new PipelinesAPI();
